module.exports = __webpack_public_path__ + "static/media/MC5@2x.e74ece70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/MC/MC5@2x.png
// module id = 699
// module chunks = 0